<div class="map-container">
    <h1>State Yield Tour</h1>
    <p>Click on one of the highlighted counties below to open the yield video for that county.</p>
    <div id="container" [chart]="mapChart"></div>
</div>
